import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';

import { defaultAllowedRoles } from '../../constants/appConstants';
import PageLoader from '../loaders/pageLoader';
import { rootLoader } from '../loaders/rootLoader';
import { settingsCardsLoader } from '../loaders/settings/settingsCardsLoader';
import { settingsCodingLoader } from '../loaders/settings/settingsCodingLoader';
import { settingsOverviewLoader } from '../loaders/settings/settingsOverviewLoader';
import { settingsTeamsLoader } from '../loaders/settings/settingsTeamsLoader';
import ProtectedRoute from '../protectedRoute';
import { queryClient } from '../queryClient';

const OverviewPage = lazy(() => import('../../components/pages/companySettings/overview'));
const TeamsPage = lazy(() => import('../../components/pages/companySettings/teams'));
const CardsPage = lazy(() => import('../../components/pages/companySettings/cards'));
const CodingPage = lazy(() => import('../../components/pages/companySettings/coding'));

const settingsPath = '/settings' as const;

export const settingsRoutes = {
	path: settingsPath,
	element: <Outlet />,
	children: [
		{
			index: true,
			element: (
				<ProtectedRoute allowedRoles={defaultAllowedRoles}>
					<Suspense fallback={<PageLoader />}>
						<OverviewPage />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, overviewData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					settingsOverviewLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...overviewData,
				};
			},
		},
		{
			path: 'overview',
			element: (
				<ProtectedRoute allowedRoles={defaultAllowedRoles}>
					<Suspense fallback={<PageLoader />}>
						<OverviewPage />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, overviewData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					settingsOverviewLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...overviewData,
				};
			},
		},
		{
			path: 'teams',
			element: (
				<ProtectedRoute allowedRoles={defaultAllowedRoles}>
					<Suspense fallback={<PageLoader />}>
						<TeamsPage />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, teamsData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					settingsTeamsLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...teamsData,
				};
			},
		},
		{
			path: 'cards',
			element: (
				<ProtectedRoute allowedRoles={defaultAllowedRoles}>
					<Suspense fallback={<PageLoader />}>
						<CardsPage />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, cardsData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					settingsCardsLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...cardsData,
				};
			},
		},
		{
			path: 'coding',
			element: (
				<ProtectedRoute allowedRoles={defaultAllowedRoles}>
					<Suspense fallback={<PageLoader />}>
						<CodingPage />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, codingData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					settingsCodingLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...codingData,
				};
			},
		},
	],
};
